import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';
import { AuthGuard } from './utilities/auth.guard';
import { AppForgotComponent } from './pages/app.forgot.component';
import { RestComponent } from './pages/rest/rest.component';
import { LandingLayoutModule } from './modules-layout/sales/landing-layout.module';
import { SalesGuard } from './utilities/sales.guard';
import { AppOtpComponent } from './pages/app.otp.component';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { SplashGuard } from './utilities/splash.guard';
import { MsalGuard } from '@azure/msal-angular';
import { AppMainComponent } from './app.main.component';


const approutes: Routes = [
  { path: '', redirectTo: 'sales', pathMatch: 'full' },
  { path: 'login', component: AppLoginComponent, canActivate: [SalesGuard] },
  { path: 'otp', component: AppOtpComponent, canActivate: [SalesGuard] },

  { path: 'forgot', component: AppForgotComponent },
  { path: 'reset', component: RestComponent },

  {
    path: 'admin',
    loadChildren: () => import('./modules-layout/admin/layout.module').then((m) => m.LayoutModule),
    data: { role: ['Admin', 'TMS', 'CMS'] },
    canActivate: [AuthGuard],
  },
  {
    path: 'selfcare',
    loadChildren: () => import('./modules-layout/selfcare/layout.module').then((m) => m.LayoutModule),
    data: { roles: ['Selfcare Admin','Shared Access'] },
    canActivate: [AuthGuard],
  },
  {
    path: 'sales',
    loadChildren: () => import('./modules-layout/sales/landing-layout.module').then((m) => m.LandingLayoutModule),
    canActivate: [SalesGuard],
  },
  {
    path: 'sales-agent',
    loadChildren: () => import('./modules-layout/sales-agent/sales-agent.module').then((m) => m.SalesAgentModule),
    canActivate: [AuthGuard],

  },
  {
  path: 'enterprise-sim',
  loadChildren: () => import('./modules-layout/enterprise-sim/layout.module').then((m) => m.LayoutModule),
  data: { role: ['Enterprise Sim'] },
  canActivate: [AuthGuard],
  },
  
  { path: 'error', component: AppErrorComponent },
  { path: 'access', component: AppAccessdeniedComponent },
  { path: 'notfound', component: AppNotfoundComponent },
  {
    path: 'getting-ready',
    loadChildren: () => import('src/app/splash-screen/splash-screen.module').then(m => m.SplashScreenModule),
    canActivate: [MsalGuard]
  },
  { path: '**', redirectTo: '/notfound' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(approutes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
